function formatShardKey(key) {
  return Object.entries(key).map(([field, dir]) => {
    if (dir === "hashed") {
      return `${field}: hashed`;
    }
    return `${field}: ${dir === 1 ? "↑" : dir === -1 ? "↓" : dir}`;
  }).join(", ");
}
export {
  formatShardKey as f
};
